import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ButtonSheetService {
  private openButtonSheet = false;
  private openButtonSheet$ = new BehaviorSubject<boolean>(this.openButtonSheet);

  private salvaButtonSheet = false;
  private salvaButtonSheet$ = new BehaviorSubject<boolean>(
    this.salvaButtonSheet
  );

  constructor() {}

  public atualizaOpenButtonSheet(openButtonSheet: boolean) {
    this.openButtonSheet = openButtonSheet;
    this.updateOpenButtonSheet();
  }

  public atualizaSalvaButtonSheet(salvaButtonSheet: boolean) {
    this.salvaButtonSheet = salvaButtonSheet;
    this.updateSalvaButtonSheet();
  }

  public updateOpenButtonSheet() {
    this.openButtonSheet$.next(this.openButtonSheet);
  }

  public getOpenButtonSheet(): Observable<boolean> {
    return this.openButtonSheet$.asObservable();
  }

  public updateSalvaButtonSheet() {
    this.salvaButtonSheet$.next(this.salvaButtonSheet);
  }

  public getSalvaButtonSheet(): Observable<boolean> {
    return this.salvaButtonSheet$.asObservable();
  }
}
